import * as React from "react"

export default function TerrainOffroadIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 28.9999C2 24.0231 1.99616 19.9108 2.89844 15.7861C3.80742 11.6309 5.62203 7.51051 9.18066 2.42671C9.49733 1.97432 10.1208 1.86407 10.5732 2.18061C11.0256 2.49728 11.1359 3.12076 10.8193 3.57319C7.37813 8.4892 5.69259 12.3691 4.85156 16.2138C4.00389 20.0891 4 23.9769 4 28.9999C4 29.5522 3.55229 29.9999 3 29.9999C2.44772 29.9999 2 29.5522 2 28.9999Z"
        fill={props.fill}
      />
      <path
        d="M23.8027 2.04682C23.3096 1.89018 22.7847 2.13589 22.583 2.60053L22.5469 2.69721L22.2285 3.73823C20.7157 8.89267 20.41 13.2682 21.3369 17.3466C22.3245 21.692 24.686 25.5883 28.2471 29.6582C28.6107 30.0737 29.2426 30.1162 29.6582 29.7529C30.0737 29.3893 30.1163 28.7574 29.7529 28.3417C26.3142 24.4118 24.1755 20.8077 23.2881 16.9033C22.4018 13.0036 22.7385 8.6915 24.4531 3.30268C24.6202 2.77654 24.3289 2.21423 23.8027 2.04682Z"
        fill={props.fill}
      />
      <path
        d="M9.2666 11.3299C9.63604 10.9194 10.2682 10.8863 10.6787 11.2557C11.0892 11.6251 11.1224 12.2573 10.7529 12.6678L10.7432 12.6785C10.3738 13.089 9.74157 13.123 9.33105 12.7537C8.92054 12.3843 8.88738 11.7512 9.25684 11.3406L9.2666 11.3299Z"
        fill={props.fill}
      />
      <path
        d="M6.2666 23.33C6.63606 22.9195 7.2682 22.8864 7.67871 23.2558C8.08922 23.6253 8.12239 24.2574 7.75293 24.6679L7.74316 24.6787C7.37371 25.0892 6.74156 25.1223 6.33106 24.7529C5.92071 24.3834 5.88743 23.7512 6.25684 23.3408L6.2666 23.33Z"
        fill={props.fill}
      />
      <path
        d="M9.2666 19.33C9.63606 18.9195 10.2682 18.8864 10.6787 19.2558C11.0892 19.6253 11.1224 20.2574 10.7529 20.6679L10.7432 20.6787C10.3737 21.0892 9.74156 21.1223 9.33105 20.7529C8.92071 20.3834 8.88743 19.7512 9.25684 19.3408L9.2666 19.33Z"
        fill={props.fill}
      />
      <path
        d="M9.2666 27.33C9.63606 26.9195 10.2682 26.8864 10.6787 27.2558C11.0892 27.6253 11.1224 28.2574 10.7529 28.6679L10.7432 28.6787C10.3737 29.0892 9.74156 29.1223 9.33105 28.7529C8.92071 28.3834 8.88743 27.7512 9.25684 27.3408L9.2666 27.33Z"
        fill={props.fill}
      />
      <path
        d="M6.2666 15.33C6.63606 14.9195 7.2682 14.8864 7.67871 15.2558C8.08922 15.6253 8.12239 16.2574 7.75293 16.6679L7.74316 16.6787C7.37371 17.0892 6.74156 17.1223 6.33106 16.7529C5.92071 16.3834 5.88743 15.7512 6.25684 15.3408L6.2666 15.33Z"
        fill={props.fill}
      />
      <path
        d="M12.2666 7.32989C12.636 6.91941 13.2682 6.88629 13.6787 7.25567C14.0892 7.62513 14.1224 8.25727 13.7529 8.66778L13.7432 8.67852C13.3738 9.08895 12.7416 9.12294 12.3311 8.75372C11.9205 8.38426 11.8874 7.75114 12.2568 7.34063L12.2666 7.32989Z"
        fill={props.fill}
      />
      <path
        d="M12.2666 23.33C12.6361 22.9195 13.2682 22.8864 13.6787 23.2558C14.0892 23.6253 14.1224 24.2574 13.7529 24.6679L13.7432 24.6787C13.3737 25.0892 12.7416 25.1223 12.3311 24.7529C11.9207 24.3834 11.8874 23.7512 12.2568 23.3408L12.2666 23.33Z"
        fill={props.fill}
      />
      <path
        d="M15.2666 19.33C15.6361 18.9195 16.2682 18.8864 16.6787 19.2558C17.0892 19.6253 17.1224 20.2574 16.7529 20.6679L16.7432 20.6787C16.3737 21.0892 15.7416 21.1223 15.3311 20.7529C14.9207 20.3834 14.8874 19.7512 15.2568 19.3408L15.2666 19.33Z"
        fill={props.fill}
      />
      <path
        d="M15.2666 11.33C15.6361 10.9195 16.2682 10.8864 16.6787 11.2558C17.0892 11.6253 17.1224 12.2574 16.7529 12.6679L16.7432 12.6787C16.3737 13.0892 15.7416 13.1223 15.3311 12.7529C14.9207 12.3834 14.8874 11.7512 15.2568 11.3408L15.2666 11.33Z"
        fill={props.fill}
      />
      <path
        d="M15.2666 3.33003C15.6361 2.91952 16.2682 2.88636 16.6787 3.25581C17.0892 3.62527 17.1224 4.25741 16.7529 4.66792L16.7432 4.67866C16.3737 5.08917 15.7416 5.12234 15.3311 4.75288C14.9207 4.3834 14.8874 3.75122 15.2568 3.34077L15.2666 3.33003Z"
        fill={props.fill}
      />
      <path
        d="M15.2666 27.33C15.6361 26.9195 16.2682 26.8864 16.6787 27.2558C17.0892 27.6253 17.1224 28.2574 16.7529 28.6679L16.7432 28.6787C16.3737 29.0892 15.7416 29.1223 15.3311 28.7529C14.9207 28.3834 14.8874 27.7512 15.2568 27.3408L15.2666 27.33Z"
        fill={props.fill}
      />
      <path
        d="M12.2666 15.33C12.6361 14.9195 13.2682 14.8864 13.6787 15.2558C14.0892 15.6253 14.1224 16.2574 13.7529 16.6679L13.7432 16.6787C13.3737 17.0892 12.7416 17.1223 12.3311 16.7529C11.9207 16.3834 11.8874 15.7512 12.2568 15.3408L12.2666 15.33Z"
        fill={props.fill}
      />
      <path
        d="M18.2666 7.33003C18.6361 6.91952 19.2682 6.88636 19.6787 7.25581C20.0892 7.62527 20.1224 8.25741 19.7529 8.66792L19.7432 8.67866C19.3737 9.08917 18.7416 9.12234 18.3311 8.75288C17.9207 8.3834 17.8874 7.75122 18.2568 7.34077L18.2666 7.33003Z"
        fill={props.fill}
      />
      <path
        d="M18.2666 23.33C18.6361 22.9195 19.2682 22.8864 19.6787 23.2558C20.0892 23.6253 20.1224 24.2574 19.7529 24.6679L19.7432 24.6787C19.3737 25.0892 18.7416 25.1223 18.3311 24.7529C17.9207 24.3834 17.8874 23.7512 18.2568 23.3408L18.2666 23.33Z"
        fill={props.fill}
      />
      <path
        d="M18.2666 15.33C18.6361 14.9195 19.2682 14.8864 19.6787 15.2558C20.0892 15.6253 20.1224 16.2574 19.7529 16.6679L19.7432 16.6787C19.3737 17.0892 18.7416 17.1223 18.3311 16.7529C17.9207 16.3834 17.8874 15.7512 18.2568 15.3408L18.2666 15.33Z"
        fill={props.fill}
      />
      <path
        d="M21.2666 27.33C21.6361 26.9195 22.2682 26.8864 22.6787 27.2558C23.0892 27.6253 23.1224 28.2574 22.7529 28.6679L22.7432 28.6787C22.3737 29.0892 21.7416 29.1223 21.3311 28.7529C20.9207 28.3834 20.8874 27.7512 21.2568 27.3408L21.2666 27.33Z"
        fill={props.fill}
      />
      <path
        d="M28 13.4999C28 13.0957 27.7838 11.8327 27.418 10.6259C27.2771 10.1612 27.125 9.74827 26.9766 9.42671C26.8294 9.74277 26.6818 10.1519 26.5459 10.6162C26.1962 11.8113 26 13.0833 26 13.4999C26 14.0522 26.4477 14.4999 27 14.4999C27.5523 14.4999 28 14.0522 28 13.4999ZM30 13.4999C30 14.8057 29.1645 15.9129 28 16.3251V17.9999C28 18.5522 27.5523 18.9999 27 18.9999C26.4477 18.9999 26 18.5522 26 17.9999V16.3251C24.8355 15.9129 24 14.8057 24 13.4999C24 12.8121 24.2518 11.3333 24.626 10.0546C24.8152 9.40798 25.0552 8.7415 25.3477 8.21675C25.4928 7.95639 25.6774 7.68241 25.9121 7.46186C26.1449 7.24314 26.513 6.99995 27 6.99995C27.5038 6.99995 27.8689 7.2734 28.0781 7.48139C28.2975 7.69954 28.4728 7.96903 28.6123 8.22456C28.8946 8.74165 29.1365 9.40105 29.332 10.0458C29.7161 11.3129 30 12.7996 30 13.4999Z"
        fill={props.fill}
      />
    </svg>
  )
}